import { render, staticRenderFns } from "./PrivacyModal.vue?vue&type=template&id=2f1c4e4e&"
import script from "./PrivacyModal.vue?vue&type=script&lang=js&"
export * from "./PrivacyModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports